import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicab() {



    const cardData = {

keyword: "Pune to Mumbai Cabs",

headingDescription:
    "Rising Cab Service offers safe and affordable Pune to Mumbai Cabs for families, business travelers, tourists, and airport passengers. We provide one-way and round-trip cab services with well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced chauffeurs. Our service includes doorstep pickup, transparent pricing, 24/7 booking support, and comfortable travel. Whether you're visiting Mumbai for business, sightseeing, or an airport transfer, Rising Cab Service ensures a smooth and hassle-free journey.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "Gateway of India is Mumbai's most iconic monument overlooking the Arabian Sea. Built during the British era, it is a popular tourist attraction and the starting point for ferry rides to Elephanta Caves."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive, also known as the Queen's Necklace, is a scenic coastal boulevard famous for its beautiful sunset views and sparkling city lights. It is one of Mumbai's most visited landmarks."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is a lively destination known for its sandy shoreline, street food, and vibrant atmosphere. Visitors enjoy evening walks, local snacks, and stunning views of the Arabian Sea."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is one of India's most revered Lord Ganesha temples, attracting millions of devotees and tourists every year seeking blessings and spiritual peace."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are a UNESCO World Heritage Site featuring ancient rock-cut caves dedicated to Lord Shiva. The intricate sculptures and historical significance make them a major attraction."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus",
        description:
            "Chhatrapati Shivaji Maharaj Terminus is a UNESCO-listed railway station known for its stunning Victorian Gothic architecture and historical importance in Mumbai."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a famous Islamic shrine located on an islet in the Arabian Sea. Its unique location and beautiful architecture attract visitors from all faiths."
    },
    {
        title: "Bandra-Worli Sea Link",
        description:
            "The Bandra-Worli Sea Link is an engineering marvel connecting key parts of Mumbai. The bridge offers spectacular sea views and has become a symbol of the city's modern development."
    },
    {
        title: "Sanjay Gandhi National Park",
        description:
            "Sanjay Gandhi National Park is a vast green space within Mumbai featuring wildlife, nature trails, and the ancient Kanheri Caves, making it a perfect destination for nature lovers."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is one of Mumbai's most famous shopping and cultural streets, offering street markets, cafes, handicrafts, fashion accessories, and a lively local atmosphere."
    }
],



services: [
    {
        name: "Pune to Mumbai Cab",
        description:
            "Rising Cab Service provides Pune to Mumbai Cab services for safe, comfortable, and affordable intercity travel through the Mumbai-Pune Expressway. Whether you are travelling for business meetings, airport transfers, family functions, tourism, or personal work, we offer clean AC vehicles, experienced drivers, and 24x7 cab availability. Customers can choose from hatchbacks, sedans, SUVs, Ertiga, Innova, Innova Crysta, and premium vehicles according to their travel requirements. We provide one-way and round-trip options with transparent pricing, instant booking, and door-to-door pickup and drop services for a hassle-free journey."
    },
    {
        name: "Pune to Mumbai Taxi",
        description:
            "Book Pune to Mumbai Taxi with Rising Cab Service for reliable and comfortable travel. Our service includes professional chauffeurs, well-maintained vehicles, flexible travel schedules, and affordable fares for business and leisure travellers."
    },
    {
        name: "Cab from Pune to Mumbai",
        description:
            "Rising Cab Service offers Cab from Pune to Mumbai with one-way and round-trip travel options. Enjoy convenient pickup, comfortable AC vehicles, and experienced highway drivers for a smooth journey."
    },
    {
        name: "Taxi from Pune to Mumbai",
        description:
            "Our Taxi from Pune to Mumbai service provides dependable transportation for individuals, families, and corporate clients with safe driving and transparent pricing."
    },
    {
        name: "Pune to Mumbai Cab Service",
        description:
            "Rising Cab Service provides Pune to Mumbai Cab Service for airport transfers, business travel, family trips, and holiday journeys with multiple vehicle options and 24x7 support."
    },
    {
        name: "Pune to Mumbai Taxi Fare",
        description:
            "Get affordable Pune to Mumbai Taxi Fare with Rising Cab Service. We provide competitive pricing, transparent billing, and value-for-money transportation without hidden charges."
    },
    {
        name: "Pune to Mumbai One Way Cab",
        description:
            "Book Pune to Mumbai One Way Cab for economical travel without paying return charges. Our one-way service is ideal for business travellers, airport transfers, and personal trips."
    },
    {
        name: "Pune to Mumbai Round Trip Taxi",
        description:
            "Rising Cab Service offers Pune to Mumbai Round Trip Taxi with flexible return schedules, waiting options, and comfortable travel for family and corporate requirements."
    },
    {
        name: "Pune to Mumbai Cab Booking",
        description:
            "Our Pune to Mumbai Cab Booking service provides instant and advance reservations with quick confirmation and multiple vehicle choices."
    },
    {
        name: "Cheap Pune to Mumbai Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Mumbai Cab with budget-friendly fares while maintaining high standards of comfort, cleanliness, and passenger safety."
    },
    {
        name: "Best Pune to Mumbai Taxi",
        description:
            "Choose the Best Pune to Mumbai Taxi with Rising Cab Service for premium travel experience, professional drivers, and dependable transportation."
    },
    {
        name: "Sedan Pune to Mumbai Cab",
        description:
            "Our Sedan Pune to Mumbai Cab service provides comfortable and spacious vehicles for individuals, couples, and small families travelling between Pune and Mumbai."
    },
    {
        name: "SUV Pune to Mumbai Taxi",
        description:
            "Book SUV Pune to Mumbai Taxi for larger groups and extra luggage requirements with comfortable seating and smooth highway travel."
    },
    {
        name: "Innova Pune to Mumbai Cab",
        description:
            "Rising Cab Service offers Innova Pune to Mumbai Cab for family trips, corporate travel, and group journeys with spacious interiors and premium comfort."
    },
    {
        name: "Expressway Taxi Pune Mumbai",
        description:
            "Our Expressway Taxi Pune Mumbai service ensures fast and safe travel through the Mumbai-Pune Expressway with experienced drivers and well-maintained vehicles."
    },
    {
        name: "Pune to Mumbai Cabs",
        description:
            "Rising Cab Service provides Pune to Mumbai Cabs with one-way, round-trip, and airport transfer options for convenient intercity travel."
    },
    {
        name: "Pune to Mumbai Cab Service",
        description:
            "Our Pune to Mumbai Cab Service offers reliable and affordable transportation with professional chauffeurs and clean AC vehicles."
    },
    {
        name: "Pune to Mumbai Taxi Service",
        description:
            "Book Pune to Mumbai Taxi Service for comfortable and stress-free travel with flexible pickup locations and transparent pricing."
    },
    {
        name: "Pune to Mumbai Cab Booking",
        description:
            "Rising Cab Service provides Pune to Mumbai Cab Booking with instant confirmation, advance reservations, and 24x7 customer support."
    },
    {
        name: "Mumbai to Pune Cab Service",
        description:
            "Our Mumbai to Pune Cab Service offers safe and comfortable return travel with one-way and round-trip options for business and leisure travellers."
    },
    {
        name: "One Way Cab Pune to Mumbai",
        description:
            "Book One Way Cab Pune to Mumbai for affordable single-trip transportation with experienced drivers and comfortable vehicles."
    },
    {
        name: "Pune to Mumbai Airport Cab",
        description:
            "Rising Cab Service provides Pune to Mumbai Airport Cab for direct transfers to Mumbai Airport with timely pickups and reliable service."
    },
    {
        name: "Cheap Pune to Mumbai Cab",
        description:
            "Our Cheap Pune to Mumbai Cab service delivers economical travel solutions without compromising safety, comfort, or reliability."
    },
    {
        name: "Best Pune to Mumbai Taxi",
        description:
            "Rising Cab Service offers one of the Best Pune to Mumbai Taxi services with premium vehicles, courteous drivers, and smooth intercity travel."
    },
    {
        name: "24x7 Pune to Mumbai Cab Service",
        description:
            "Book 24x7 Pune to Mumbai Cab Service with Rising Cab Service for round-the-clock travel with instant availability and dependable transportation."
    },
    {
        name: "Pune Mumbai Taxi",
        description:
            "Our Pune Mumbai Taxi service provides flexible one-way and round-trip travel with affordable pricing and comfortable vehicles for all travel needs."
    }
],

tableData: [
    ["Pune to Mumbai Cab", "Pune to Mumbai Taxi"],
    ["Cab from Pune to Mumbai", "Taxi from Pune to Mumbai"],
    ["Pune to Mumbai Cab Service", "Pune to Mumbai Taxi Fare"],
    ["Pune to Mumbai One Way Cab", "Pune to Mumbai Round Trip Taxi"],
    ["Pune to Mumbai Cab Booking", "Cheap Pune to Mumbai Cab"],
    ["Best Pune to Mumbai Taxi", "Sedan Pune to Mumbai Cab"],
    ["SUV Pune to Mumbai Taxi", "Innova Pune to Mumbai Cab"],
    ["Expressway Taxi Pune Mumbai", "Pune to Mumbai Cabs"],
    ["Pune to Mumbai Cab Service", "Pune to Mumbai Taxi Service"],
    ["Pune to Mumbai Cab Booking", "Mumbai to Pune Cab Service"],
    ["One Way Cab Pune to Mumbai", "Pune to Mumbai Airport Cab"],
    ["Cheap Pune to Mumbai Cab", "Best Pune to Mumbai Taxi"],
    ["24x7 Pune to Mumbai Cab Service", "Pune Mumbai Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Fast and Reliable Pune to Mumbai Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Mumbai cab transportation for business travelers, families, tourists, students, and corporate professionals."
    },
    {
        WhyChooseheading: "Ideal for Airport and City Transfers",
        WhyChoosedescription: "Whether you're traveling to Mumbai Airport, Navi Mumbai, South Mumbai, Thane, or business districts, our cab service offers convenient door-to-door transportation."
    },
    {
        WhyChooseheading: "Multiple Vehicle Choices for Every Traveler",
        WhyChoosedescription: "Select from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your travel preferences and passenger count."
    },
    {
        WhyChooseheading: "Convenient One-Way and Return Trips",
        WhyChoosedescription: "Customers can choose one-way cab services, same-day return plans, multi-day travel, or customized packages according to their schedule."
    },
    {
        WhyChooseheading: "Comfortable Highway Travel Experience",
        WhyChoosedescription: "Our vehicles are maintained for long-distance travel, ensuring smooth journeys through the Mumbai-Pune Expressway and surrounding routes."
    },
    {
        WhyChooseheading: "Pickup from Any Pune Location",
        WhyChoosedescription: "Cab pickup facilities are available from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and all major Pune locations."
    },
    {
        WhyChooseheading: "Popular Choice for Business Travelers",
        WhyChoosedescription: "Many professionals prefer our Pune to Mumbai cabs for meetings, conferences, corporate visits, airport transfers, and executive travel."
    },
    {
        WhyChooseheading: "Flexible Travel Timings Throughout the Day",
        WhyChoosedescription: "Rising Cab Service allows customers to schedule departures according to their convenience, including early morning and late-night travel."
    }
]
};

const faqData = [
    {
        question: "How frequently do customers book Pune to Mumbai cabs?",
        answer: "Pune to Mumbai is one of the most popular intercity travel routes used by business travelers, families, tourists, and corporate employees."
    },
    {
        question: "Can passengers travel directly to Mumbai Airport from Pune?",
        answer: "Yes, direct transportation is available to both Chhatrapati Shivaji Maharaj International Airport and domestic terminals."
    },
    {
        question: "Which vehicle category is commonly preferred for this route?",
        answer: "Sedan cars, Ertiga, and Innova Crysta are among the most frequently selected vehicles for Pune to Mumbai travel."
    },
    {
        question: "Are one-way cab bookings available between Pune and Mumbai?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel options."
    },
    {
        question: "Can travelers schedule same-day return journeys?",
        answer: "Yes, same-day return packages can be arranged for business meetings, personal visits, and corporate travel."
    },
    {
        question: "Do families choose this service for vacations and events?",
        answer: "Yes, families regularly use Pune to Mumbai cabs for holidays, functions, celebrations, and sightseeing trips."
    },
    {
        question: "Are larger vehicles available for group travel?",
        answer: "Yes, Tempo Travellers and group transportation vehicles can be arranged for larger travel groups."
    },
    {
        question: "Can pickups be arranged from Pune Airport or Railway Station?",
        answer: "Yes, customers can start their journey directly from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance reservation beneficial for Pune to Mumbai travel?",
        answer: "Yes, booking in advance helps secure preferred vehicle options and smoother travel planning."
    },
    {
        question: "How can customers confirm a Pune to Mumbai cab booking?",
        answer: "Reservations can be completed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Gokhale",
        feedback:
            "Traveling to Mumbai for client meetings has become much more convenient with Rising Cab Service. The journey is always comfortable, and the drivers are highly professional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Riddhi Joshi",
        feedback:
            "A recent family visit to Mumbai was handled perfectly. The vehicle was spacious, the ride was smooth, and the overall travel experience was truly enjoyable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mumbai Cabs",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mumbai-cabs.jpg",
"description": "Book Pune to Mumbai Cabs with Rising Cab Service for safe, comfortable, and affordable intercity travel. Enjoy reliable one-way and round-trip taxi service between Pune and Mumbai with professional drivers and AC cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mumbai-cabs"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Cabs | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mumbai Cabs for one-way and round-trip travel. Get affordable, safe, and reliable taxi service with AC sedans and SUVs for smooth intercity journeys."
/>

<meta
 name="keywords"
 content="Pune to mumbai cab, pune to mumbai taxi, cab from pune to mumbai, taxi from pune to mumbai, pune to mumbai cab service, pune to mumbai taxi fare, pune to mumbai one way cab, pune to mumbai round trip taxi, pune to mumbai cab booking, cheap pune to mumbai cab, best pune to mumbai taxi, sedan pune to mumbai cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaicab;